import React from 'react';
import { DigitalIcon, BookIcon, PremiumIcon, ArrowRightIcon, CheckmarkIcon, SecureIcon, GuaranteeIcon, SupportIcon } from './icons/CustomIcons';
export function PurchaseOptions() {
  const options = [{
    title: 'Digital Copy',
    price: '$19.97',
    icon: <DigitalIcon className="w-12 h-12 text-[#0c2340] mb-4" data-id="element-199" />,
    features: ['Instant delivery to your email', 'Read on any device', 'Searchable text', 'Highlight and take notes'],
    recommended: false,
    color: 'bg-blue-50',
    freeShipping: false
  }, {
    title: 'Physical Copy',
    price: '$39.97',
    icon: <BookIcon className="w-12 h-12 text-[#0c2340] mb-4" data-id="element-200" />,
    features: ['Premium paperback edition', 'Signed by the author', 'Free shipping in the US', 'Includes digital copy'],
    recommended: false,
    color: 'bg-amber-50',
    freeShipping: true
  }, {
    title: 'Premium Hardcover Limited Edition',
    price: '$94.97',
    icon: <PremiumIcon className="w-12 h-12 text-[#0c2340] mb-4" data-id="element-201" />,
    features: ['Deluxe hardcover with gold embossing', 'Numbered limited edition', 'Personally signed by Charlie Kirk', 'Exclusive bonus chapter', 'Includes digital copy'],
    recommended: true,
    color: 'bg-[#e9d28f]',
    freeShipping: true
  }];
  return <div className="w-full py-16 px-4 md:px-8 lg:px-16 bg-white" id="pricing-section" data-id="element-202">
      <div className="max-w-6xl mx-auto" data-id="element-203">
        <div className="text-center mb-12" data-id="element-204">
          <h2 className="text-3xl font-bold mb-4 text-[#0c2340]" data-id="element-205">
            Choose Your Edition
          </h2>
          <p className="text-xl" data-id="element-206">
            Don't let this moment pass you by. Be among the first to own
            Unshakable Conviction.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-207">
          {options.map((option, index) => <div key={index} className={`rounded-lg shadow-lg overflow-hidden flex flex-col ${option.recommended ? 'md:transform md:-translate-y-4' : ''}`} data-id="element-208">
              {option.recommended && <div className="bg-red-700 text-white text-center py-2 font-bold" data-id="element-209">
                  EXCLUSIVE LIMITED EDITION
                </div>}
              <div className={`p-8 ${option.color} flex-1 flex flex-col`} data-id="element-210">
                <div className="flex justify-center" data-id="element-211">{option.icon}</div>
                <h3 className="text-xl font-bold text-center mb-2" data-id="element-212">
                  {option.title}
                </h3>
                <p className="text-3xl font-bold text-center mb-6" data-id="element-213">
                  {option.price}
                </p>
                {option.freeShipping && <div className="flex justify-center mb-4" data-id="element-214">
                    <span className="bg-green-100 text-green-800 font-semibold px-3 py-1 rounded-full text-sm border border-green-300" data-id="element-215">
                      FREE SHIPPING
                    </span>
                  </div>}
                {option.recommended && <div className="flex justify-center mb-6 md:hidden" data-id="element-216">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8trgeA7VZR5XjJR2ciDSJW/Generated_Image_September_26%2C_2025_-_6_11PM.png" alt="Unshakable Conviction Book Cover" className="w-full h-auto rounded-md shadow-xl" data-id="element-217" />
                  </div>}
                <ul className="mb-6 mt-2 space-y-2 flex-1" data-id="element-218">
                  {option.features.map((feature, idx) => <li key={idx} className="flex items-center" data-id="element-219">
                      <CheckmarkIcon className="w-5 h-5 text-green-600 mr-2 flex-shrink-0" data-id="element-220" />
                      <span data-id="element-221">{feature}</span>
                    </li>)}
                </ul>
                <div className="mt-auto" data-id="element-222">
                  <button onClick={() => window.location.href = 'https://www.voicesoffreedomus.com/cart/45193640050874:1'} className={`w-full py-3 px-6 rounded-md font-bold transition duration-300 flex items-center justify-center ${option.recommended ? 'bg-red-700 hover:bg-red-800 text-white' : 'bg-[#0c2340] hover:bg-[#1a3a6c] text-white'}`} data-id="element-223">
                    Order Now
                    <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-224" />
                  </button>
                  <div className="flex justify-center items-center mt-4 space-x-2" data-id="element-225">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ujrVqcd5fH7gqUH9rh9gz5/stb.png" alt="Payment methods" className="h-8" data-id="element-226" />
                  </div>
                  <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-227">
                    <div className="grid grid-cols-3 w-full" data-id="element-228">
                      <div className="flex flex-col items-center" data-id="element-229">
                        <SecureIcon className="text-green-600 w-6 h-6" data-id="element-230" />
                        <span className="text-xs font-medium mt-1 text-center text-gray-600" data-id="element-231">
                          Secure Checkout
                        </span>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-232">
                        <GuaranteeIcon className="text-blue-600 w-6 h-6" data-id="element-233" />
                        <span className="text-xs font-medium mt-1 text-center text-gray-600" data-id="element-234">
                          30-Day Guarantee
                        </span>
                      </div>
                      <div className="flex flex-col items-center" data-id="element-235">
                        <SupportIcon className="text-purple-600 w-6 h-6" data-id="element-236" />
                        <span className="text-xs font-medium mt-1 text-center text-gray-600" data-id="element-237">
                          24/7 Support
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}